import type { FaireProductEntity } from "../../entity_types/product";

export const p_bdbepjfbv4: FaireProductEntity = {
  token: "p_bdbepjfbv4",
  type: "product",
  name: "Stripe Plush Throw - Mocha & Cream",
  brandToken: "b_3ltt834j6o",
  brandName: "Sundream",
  imageUrl:
    "https://cdn.faire.com/fastly/667741e7974ce39775bab3ad191f7c07d939c4cc0b9949f4b1ac7c2818871d19.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/213816c441d6e45b44f14ddba3cf5fa3fc85c4d3e864a32a00b3daf1ea8dc7cd.jpeg",
    "https://cdn.faire.com/fastly/47a301d7d1253b9b7ac64b6868ef1c6059d401622d55f2a2e4262486b7350d01.jpeg",
    "https://cdn.faire.com/fastly/ec1f085a26a8ddbf1b824e57c628d99181b4234a623360d2f3b5d90b96e4c5ff.png",
  ],
  priceDollars: 34,
  description:
    "Introducing the newest and coziest blanket in the Sundream lineup: the DreamPlush Throw. These throws are like wrapping yourself in a cloud—soft, dreamy, and irresistibly plush. Whether you’re curling up on the couch or catching a sunset, the DreamPlush throws bring next-level comfort to every moment.\n\nThe best part? They're reversible!\n\n• Unreal Softness: Made from 100% polyester, these throws feel like wrapping up in a tropical cloud.\n• Perfectly Sized: Generous 50” x 60” dimensions—big enough for couch snuggles, solo Netflix binges, or cozy backyard hangs.\n• Family Favorite: Kids adore them (seriously, they’ll steal yours). Once you try it, no other blanket compares.\n• Everyday Cozy: Great for indoor lounging or cozy evenings outside—your new go-to for any vibe.\n• So Many Options: Available in 6 dreamy styles and colors. You’ll want one for every room (and then some).\n• Gift-Worthy Goodness: The ultimate treat for yourself or a perfect gift that everyone will love.\n\n• Brown Pinstripe Blanket\n• Vertical Stripe Blanket\n• Vertical Stripe\n• Brown Stripe\n• Throw Blanket",
  tags: [],
  msrpDollars: 68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:52.469Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
